import { buildCrossDomainUrl } from "./sessionBridge";
import { auth } from "./firebase";

/**
 * Returns the absolute URL for a given path based on whether it is main, codebox, or admin.
 * Handles local development ports vs production domains.
 */
export const getAbsoluteUrl = (path) => {
  const host = window.location.hostname;
  const protocol = window.location.protocol;
  
  const isLocal = host.includes("localhost") || host.includes("127.0.0.1") || host.includes(".local");
  
  if (isLocal) {
    // local development setup (Main: 3000, Codebox: 3000 on subhost or port mapping)
    const cleanHost = host.replace("admin.", "").replace("codebox.", "");
    const cleanHostNoPort = cleanHost.split(':')[0];
    
    if (path.startsWith("/admin")) {
      return `${protocol}//admin.${cleanHostNoPort}:3000${path}`;
    }
    if (path.startsWith("/codebox")) {
      const subPath = path.replace(/^\/codebox/, "") || "/";
      const normalized = subPath.startsWith('/') ? subPath : `/${subPath}`;
      return `${protocol}//codebox.${cleanHostNoPort}:3000${normalized}`;
    }
    return `${protocol}//${cleanHostNoPort}:3000${path}`;
  } else {
    // production domains mapping
    if (path.startsWith("/admin")) {
      return `https://admin.siliconlogix.in${path}`;
    }
    if (path.startsWith("/codebox")) {
      const subPath = path.replace(/^\/codebox/, "") || "/";
      const normalized = subPath.startsWith('/') ? subPath : `/${subPath}`;
      return `https://codebox.siliconlogix.in${normalized}`;
    }
    return `https://siliconlogix.in${path}`;
  }
};

/**
 * Builds a secured cross-domain CodeBox URL with embedded session handoff fallback.
 */
export const buildCodeBoxUrl = (targetPath = "/", user = null) => {
  const normalized = targetPath.startsWith('/') ? targetPath : `/${targetPath}`;
  const targetUrl = getAbsoluteUrl(`/codebox${normalized === '/' ? '' : normalized}`);
  const activeUser = user || (auth && auth.currentUser);
  return buildCrossDomainUrl(targetUrl, activeUser);
};

/**
 * Builds a secured cross-domain Main Portal URL with embedded session handoff fallback.
 */
export const buildMainUrl = (targetPath = "/", user = null) => {
  const normalized = targetPath.startsWith('/') ? targetPath : `/${targetPath}`;
  const targetUrl = getAbsoluteUrl(normalized);
  const activeUser = user || (auth && auth.currentUser);
  return buildCrossDomainUrl(targetUrl, activeUser);
};

/**
 * Checks if a target path matches the current site type.
 */
export const isSameSite = (to) => {
  const host = window.location.hostname;
  
  let currentSite = "main";
  if (host.startsWith("admin.")) currentSite = "admin";
  else if (host.startsWith("codebox.")) currentSite = "codebox";

  let targetSite = "main";
  if (to.startsWith("/admin")) targetSite = "admin";
  else if (to.startsWith("/codebox")) targetSite = "codebox";

  return currentSite === targetSite;
};
